// ======================================================================
// File Name       : SelectGroupListDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Col, Button, Table, FormControl } from 'react-bootstrap';
import * as userActions from '../../actions/UserAction';
import { MESSAGE_TYPE, MESSAGE_TIME_OUT, MODAL_SIZE, RETURN_MAX_NUM } from '../../constants/index';
import GroupTree from '../../components/group/GroupTree';
import TableHead from '../../components/TableHead';
import * as courseActions from '../../actions/CourseAction';
import Pagination from '../../components/Pagination';
import * as userAction from '../../actions/UserAction';

class SelectGroupListDlg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTargetGroup: [],
      groupName: '',
      startPosition: 0,
      userGroupRelationInfo: {},
    };
    this.handleGroupCheck = this.handleGroupCheck.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentWillMount() {
    const { dispatch, selectedGroup, userInfo, groupList } = this.props;
    
    if (!groupList || (groupList && groupList.length <= 0)) {
      this.props.dispatch(userActions.getGroupList(undefined, false));
    }
    dispatch(userAction.getUserGroupRelationList({ userList: [userInfo.userSecernId] })).then(
      (result) => {
        const { recordNum, groupRelationList } = result;
        this.setState({
          userGroupRelationInfo: result,
        });
      },
    );
  }

  /**
   * Handle event when click on OK of select group dialog
   *
   */
  onOK() {
    this.props.onOK(this.state.selectedTargetGroup);
  }

  handleGroupCheck(event) {
    const { value, checked } = event.target;
    const { selectedTargetGroup } = this.state;
    const index = selectedTargetGroup.indexOf(value);
    if (checked && index === -1) {
      selectedTargetGroup.push(value);
    }
    if (!checked && index !== -1) {
      selectedTargetGroup.splice(index, 1);
    }
    this.setState({
      selectedTargetGroup,
    });
  }

  handlePageChange(startPosition) {
    const { dispatch, course, userInfo } = this.props;
    const searchInfo = {
      userList: [userInfo.userSecernId],
      startPosition,
      returnMaxNum: RETURN_MAX_NUM,
    };
    dispatch(userAction.getUserGroupRelationList(searchInfo)).then((result) => {
      const { recordNum, groupRelationList } = result;
      this.setState({
        startPosition,
        userGroupRelationInfo: result,
      });
    });
  }

  /**
   * Render GUI
   * @returns {XML}
   */
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };

    const { userGroupRelationInfo } = this.state;
    const { recordNum, groupRelationList } = userGroupRelationInfo;

    // data of the thead's table
    const thead = [
      { title: '', sortBy: null, width: 40 },
      { title: 'ユーザーグループ名', sortBy: null },
    ];
    const { groupList, selectedGroup } = this.props;
    const { selectedTargetGroup } = this.state;
    const selectedGroupIds = selectedGroup && selectedGroup.reduce((ids, curr) => {
      ids.push(curr.groupSecernId);
      return ids;
    }, []);

    const groupListObj = groupList && groupList.reduce((obj, cur) => {
      obj[cur.groupSecernId] = cur;
      return obj;
    }, {});
    // data of the tbody's table
    const tableData =
      groupRelationList &&
      groupRelationList.map((group, index) => {
        let isChecked = false;
        let isDisabled = false;
        let groupName = '';
        if (groupListObj && groupListObj[group.groupSecernId] && groupListObj[group.groupSecernId].groupName) {
          groupName = groupListObj[group.groupSecernId].groupName;
        }
        // hold state of the checkbox
        if (selectedTargetGroup.indexOf(group.groupSecernId) !== -1) {
          isChecked = true;
        }
        // check and auto add checked and disabled on the checkbox
        if (selectedGroupIds.indexOf(group.groupSecernId) !== -1) {
          isDisabled = true;
          isChecked = true;
        }
        return (
          <tr key={group.groupSecernId}>
            <td>
              <Form.Check
                type='checkbox'
                className="text-center padding-clear margin-top-4"
                value={group.groupSecernId}
                checked={isChecked}
                onChange={this.handleGroupCheck}
                disabled={isDisabled} />
            </td>
            <td>{groupName}</td>
          </tr>
        );
      });

    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={MODAL_SIZE.lg}
        style={style}
      >
        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center margin-top-10">
            ユーザーグループを選択してください
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="padding-10">
          <Col sm={12}>
            <Form className='form-horizontal'>
              <Col sm={12} className="text-right padding-left-right-clear">
                <Pagination
                  className="margin-clear"
                  startPosition={this.state.startPosition}
                  recordNum={recordNum}
                  handlePageSelect={this.handlePageChange}
                />
              </Col>
              <Table striped hover>
                <thead>
                  <TableHead data={thead} />
                </thead>
                <tbody>{tableData}</tbody>
              </Table>
            </Form>
          </Col>
        </Modal.Body>
        <Modal.Footer className="text-center">
          <Button variant="default" className="btn-96 margin-10" onClick={this.props.onCancel}>
            キャンセル
          </Button>
          <Button variant="primary" className="btn-96 margin-10" onClick={this.onOK.bind(this)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { user } = state;
  const { groupList } = user;
  return {
    groupList,
  };
};

export default connect(mapStateToProps)(SelectGroupListDlg);
